






















import Engine, { Phase } from "@gaia-project/engine";
import { roundScoringEvents } from "@gaia-project/engine/src/tiles/scoring";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { eventDesc } from "../data/event";
import Condition from "./Condition.vue";
import Operator from "./Operator.vue";
import Resource from "./Resource.vue";

@Component<ScoringTile>({
  components: {
    Condition,
    Operator,
    Resource,
  },
})
export default class ScoringTile extends Vue {
  @Prop()
  round: number;

  get tile() {
    return this.engine.tiles.scorings.round[this.round - 1];
  }

  get event() {
    return roundScoringEvents(this.tile, this.round)[0];
  }

  get reward() {
    return this.event.rewards[0];
  }

  get engine(): Engine {
    return this.$store.state.data;
  }

  get tooltip() {
    return eventDesc(this.event, this.engine.expansions);
  }

  get highlighted() {
    return this.engine.round === this.round && !this.faded;
  }

  get faded() {
    return this.engine.round > this.round || this.engine.phase === Phase.EndGame;
  }
}
